export default "__VITE_ASSET__C9IT3Yep__"